import { render, staticRenderFns } from "./forms-category-document-modal-header.vue?vue&type=template&id=9065662a&"
import script from "./forms-category-document-modal-header.vue?vue&type=script&lang=js&"
export * from "./forms-category-document-modal-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports